// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] || chunkId) + "." + {"126":"460e4448","285":"cc7b3c1b","387":"219fd025","517":"ee178228","631":"839b0bed","787":"4a21b8e5","935":"087266de","996":"2bf20ade"}[chunkId] + ".chunk.js";
};